import { autoinject } from "aurelia-framework";

import { HospiceClient } from "../common/hospice-client";
import {
    IGetHopeCenterResponse,
    IHopeCenterSymptomTrackerInfoTopModel,
    IHopeSignaturesResponse,
    IGetHopeAdmissionFormSectionTableQuery,
    IReplaceAnswerHopeAdmissionFormSectionTableQuery,
    IHopeAdmissionFormSectionTableDetails
} from "../interfaces/i-hope-center";
import { IGetHuvAndSfvDue } from "../interfaces/i-huv-and-sfv-status";

@autoinject()
export class HopeCenterService {
    private _httpClient: HospiceClient;
    private _baseUrl: string = "/api/v1/hope";

    public constructor(httpClient: HospiceClient) {
        this._httpClient = httpClient;
    }

    public async getHopeCenterInfoById(patientId: string): Promise<IGetHopeCenterResponse> {
        return await this._httpClient
            .build(`${this._baseUrl}/center/${patientId}`)
            .useMethod("GET")
            .fetch<IGetHopeCenterResponse>();
    }

    public async getSymptomTrackerInfoById(patientId: string): Promise<IHopeCenterSymptomTrackerInfoTopModel> {
        return await this._httpClient
            .build(`${this._baseUrl}/center/${patientId}/symptom-tracker`)
            .useMethod("GET")
            .fetch<IHopeCenterSymptomTrackerInfoTopModel>();
    }

    public async getHopeTableInfoForHopeAdmissionForm(
        hopeExportId: string,
        query: IGetHopeAdmissionFormSectionTableQuery
    ): Promise<IHopeAdmissionFormSectionTableDetails[]> {
        return await this._httpClient
            .build(`${this._baseUrl}/export/${hopeExportId}/table-sections`)
            .useMethod("POST")
            .useBody(query)
            .fetch<IHopeAdmissionFormSectionTableDetails[]>();
    }

    public async replaceAnswerHopeTableInfoSectionsRowInAdmissionForm(
        hopeExportId: string,
        query: IReplaceAnswerHopeAdmissionFormSectionTableQuery
    ) {
        return await this._httpClient
            .build(`${this._baseUrl}/export/${hopeExportId}/replace-answer`)
            .useMethod("PUT")
            .useBody(query)
            .fetchNoContent();
    }

    public async getSectionZSignatures(hopeId: string): Promise<IHopeSignaturesResponse> {
        return await this._httpClient
            .build(`${this._baseUrl}/export/${hopeId}/signatures`)
            .useMethod("GET")
            .fetch<IHopeSignaturesResponse>();
    }

    public async getHuvAndSfvDue(locationIds: string[]) {
        return await this._httpClient
            .build(`${this._baseUrl}/widget/huv-and-sfv`)
            .useQueryString({ locationIds })
            .fetch<IGetHuvAndSfvDue>();
    }
}
